// Main
import { formInitialization } from "./form";

//  Helper
import { validateForm } from "./validation";

export { formInitialization, validateForm };
